import { Badge, type BadgeTone } from "@/components/ui/badge"
import type { RoleKey } from "@/types/inertia"

// Role-aware Badge wrapper. Color choice mirrors the design mockup:
//   super_admin   → red/pink   (most powerful)
//   admin         → gold       (delegated power)
//   agent_manager → warning    (team lead)
//   agent         → neutral    (rank-and-file)
//
// Centralized so every list/drawer/modal that renders a role label picks
// the same color. Adding a role in CompanyUser#enum requires one line here.

const ROLE_TONE: Record<RoleKey, BadgeTone> = {
  super_admin:   "red",
  admin:         "gold",
  agent_manager: "warning",
  agent:         "neutral",
}

export const ROLE_LABEL: Record<RoleKey, string> = {
  super_admin:   "Super admin",
  admin:         "Admin",
  agent_manager: "Agent manager",
  agent:         "Agent",
}

type Props = {
  role: RoleKey
  className?: string
}

export function RolePill({ role, className }: Props) {
  return (
    <Badge tone={ROLE_TONE[role] ?? "neutral"} className={className}>
      {ROLE_LABEL[role] ?? role}
    </Badge>
  )
}
